import React, { useEffect, useMemo, useRef, useState } from 'react';
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import { ACTIVE, ALL, DELETED, LOCKED, PACKAGENOTSENT, PACKAGESENT } from 'src/constants/commonConstants';
import { Columns, LazyTableState } from "src/models/components/dataTableWrapperModel";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import CustomizeTable from "src/components/Common/CustomizeTable/CustomizeTable";
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { Button, Col, Input, Row, UncontrolledTooltip } from 'reactstrap';
import Select from 'src/components/Common/Select';
import { Option } from "src/models/components/inputWrapperModel";
import DataTableWrapper from 'src/components/Grid/DataTableWrapper';
import SortIcon from 'src/components/Common/CustomFilterandSortIcon/SortIcon';
import FilterIcon from 'src/components/Common/CustomFilterandSortIcon/FilterIcon';
import FeatherIcon from "feather-icons-react";
import ExportFile from 'src/components/Common/ExcelPdf Export/ExportFile';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getJobSheetReportsLoading } from 'src/store/actions';
import { RootReducerState } from 'src/store/reducers';
import { convertTagToText, formatDateMEL, formatDateMELForExcel, saveAsExcelFile } from 'src/helpers/common_helpers';
import StatusHghlighter from 'src/components/Common/StatusHighlighter/StatusHighlighter';
import { jobsheetReportsList } from 'src/models/pages/jobSheetReportsModel';
import { useToast } from 'src/components/Common/ReactToaster';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { API } from 'src/util/api';
import HtmltoPlainText from 'src/components/atoms/HtmltoPlainText';
import { customizeTableColumns } from 'src/models/components/CustomizeTableColumns';


const jobsheetReportListConverson = (values: any) => {
  const modifeidValue = values?.items?.items?.map((eachValue: any) => {
    let data: any = {};
    data['id'] = eachValue?.id;
    data['JobSheet'] = eachValue?.jobNumber;
    data['complaintReportedOn'] = eachValue?.complaintReportedOn;
    data['partDespatchedFromMelOn'] = eachValue?.partDispatchedFromMelOn;
    data['melTat'] = eachValue?.melTat;
    data['partReceivedByMelOn'] = eachValue?.partReceivedByMelOn;
    data['toatlTat'] = eachValue?.totalTat;
    data['total'] = eachValue?.total;  // --missing
    data['model'] = eachValue?.model ? eachValue?.model : "-";
    data['dealerName'] = eachValue?.dealerName ? eachValue?.dealerName : "-";
    data['location'] = eachValue?.location ? eachValue?.location : "-";
    data['dealerCode'] = eachValue?.dealerCode ? eachValue?.dealerCode : "-";
    data['dealerContactPerson'] = eachValue?.dealerContactPerson ? eachValue?.dealerContactPerson : "-";
    data['dealerContactMobile'] = eachValue?.dealerContactMobile ? eachValue?.dealerContactMobile : "-";
    data['vinNumber'] = eachValue?.vinNumber ? eachValue?.vinNumber : "-";
    data['audioSerialNumber'] = eachValue?.audioSerialNumber ? eachValue?.audioSerialNumber : "-";
    data['manufacturedDate'] = eachValue?.manuFacturedDate;
    data['vehicleSaleDate'] = eachValue?.vehicleSaleDate;
    data['vehicleRepairDate'] = eachValue?.vehicleRepairDate;
    data['mis'] = eachValue?.mis ? eachValue?.mis : "-";
    data['warrantyStatus'] = eachValue?.warrantyStatus ? eachValue?.warrantyStatus : "-";
    data['kmsRun'] = eachValue?.kmsRun;
    data['concernDescription'] = eachValue?.concernDescription ? <HtmltoPlainText htmlString={eachValue?.concernDescription} /> : "-";
    data['melSymptom'] = <HtmltoPlainText htmlString={eachValue?.melSymptom} />;
    data['replacementDetails'] = <HtmltoPlainText htmlString={eachValue?.replacementDetail} />;
    data['partReceivedByDealerOn'] = eachValue?.partReceivedByDealerOn;
    data['estimateGivenDate'] = eachValue?.estimationDate;
    data['approvedDate'] = formatDateMEL(eachValue?.estimationApprovedDate);
    data['zone'] = eachValue?.zone;
    data['parts'] = eachValue?.parts;
    data['status'] = eachValue?.status;
    data['customerName'] = eachValue?.customerName; // --missing
    data['customerContactPerson'] = eachValue?.customerContactPerson;
    data['customerContactMobile'] = eachValue?.customerContactMobile;
    data['isExchange'] = eachValue?.isExchange;
    data['isFaultySystemAvailable'] = eachValue?.isFaultySystemAvailable;
    data['creationTime'] = eachValue?.creationTime;
    data['jobPrefix'] = eachValue?.jobPrefix;
    return data;
  });

  return modifeidValue?.sort((a: any, b: any) => {
    if (a?.JobSheet === null) return 1;
    if (b?.JobSheet === null) return -1;
  
    return a?.JobSheet?.localeCompare(b?.JobSheet);
  });
}
const JobSheetReports = () => {

  const filterDetails: DataTableFilterMeta = {
    JobSheet: { value: "", matchMode: "contains" },
    complaintReportedOn: { value: "", matchMode: "contains" },
    partDespatchedFromMelOn: { value: "", matchMode: "contains" },
    melTat: { value: "", matchMode: "contains" },
    SupplierId: { value: "", matchMode: "contains" },
    PoNumber: { value: "", matchMode: "contains" },
    generatedDate: { value: "", matchMode: "contains" },
    approvedDate: { value: "", matchMode: "contains" },
    GeneratedStartDate: { value: "", matchMode: "contains" },
    GeneratedEndDate: { value: "", matchMode: "contains" },
    PartReceivedByDealerStartDate: { value: "", matchMode: "contains" },
    PartReceivedByDealerEndDate: { value: "", matchMode: "contains" },
    PartReceivedOnMelStartDate: { value: "", matchMode: "contains" },
    PartReceivedOnMelEndDate: { value: "", matchMode: "contains" },
    CreationTimeStartDate: { value: "", matchMode: "contains" },
    CreationTimeEndDate: { value: "", matchMode: "contains" },
    ApprovedStartDate: { value: "", matchMode: "contains" },
    ApprovedEndDate: { value: "", matchMode: "contains" },
    CompalintReportedStartDate: { value: "", matchMode: "contains" },
    CompalintReportedEndDate: { value: "", matchMode: "contains" },
    PartDispatchedOnMelStartDate: { value: "", matchMode: "contains" },
    PartDispatchedOnMelEndDate: { value: "", matchMode: "contains" },
    EstimateGivenStartDate: { value: "", matchMode: "contains" },
    estimateGivenDate: { value: "", matchMode: "contains" },
    vinNumber: { value: "", matchMode: "contains" },
    partReceivedByMelOn: { value: "", matchMode: "contains" },
    partReceivedByDealerOn: { value: "", matchMode: "contains" },
    EstimateGivenEndDate: { value: "", matchMode: "contains" },
    BuyingCurrency: { value: "", matchMode: "contains" },
    All: { value: null, matchMode: "contains" },
    IsDeleted: { value: "false", matchMode: "contains" },
    packageSent: { value: "false", matchMode: "contains" },
    packageNotSent: { value: "false", matchMode: "contains" },
    creationTime: { value: "", matchMode: "contains" },
    jobPrefix: { value: "", matchMode: "contains" },
  };


  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    sortField: "creationTime",
    sortOrder: -1,
    filters: filterDetails,
  };

  const statusBodyTemplate = (rowData: jobsheetReportsList, field: string) => {
    let status = rowData[field] as boolean;
    return (
      <StatusHghlighter status={status} />
    );
  };


  const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (<>
      <label htmlFor="">Start Date</label>
      <Input type="date"
        required
        name={options?.value?.startDate}
        value={options?.value?.startDate || ""}
        max={options?.value?.endDate ? options?.value?.endDate : ""}
        onChange={(e: any) => {
          options;
          let modifiedDate: any = options.value || { startDate: "", endDate: "" };
          modifiedDate['startDate'] = e.target.value;
          options.filterCallback(modifiedDate, options.index);
        }} />
      <br />
      <label htmlFor="">End Date</label>
      <Input type="date"
        required
        name={options?.value?.endDate}
        value={options?.value?.endDate || ""}
        min={options?.value?.startDate ? options?.value?.startDate : ""}
        onChange={(e: any) => {
          options;
          let modifiedDate: any = options.value || { startDate: "", endDate: "" };
          modifiedDate['endDate'] = e.target.value;
          options.filterCallback(modifiedDate, options.index);
        }} />
    </>);
  };



  const convertTimesToMinutes = (minutes: any) => {
    let years = Math.floor(minutes / (60 * 24 * 365));
    minutes %= (60 * 24 * 365);
    let months = Math.floor(minutes / (60 * 24 * 30));
    minutes %= (60 * 24 * 30);
    let days = Math.floor(minutes / (60 * 24));
    minutes %= (60 * 24);
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    let output = [];
    if (years > 0) {
      output.push(`${years}y`);
    }
    if (months > 0) {
      output.push(`${months}m`);
    }
    if (days > 0) {
      output.push(`${days}d`);
    }
    if (hours > 0) {
      output.push(`${hours}h`);
    }
    if (remainingMinutes > 0) {
      output.push(`${remainingMinutes.toFixed(1)}m`);
    }
    if (output.length === 0) {
      return "less than a minute";
    } else {
      return (output.join(", "));
    }
  };

  const headerTemplate = (val: any): any => {
    return (
      convertTimesToMinutes(val)
    );
  };

  const columns: Columns[] = [
    // {
    //   field: "select",
    //   sortable: false,
    //   header: "",
    //   filter: false,
    //   showFilterMenu: false,
    //   selectionMode: "multiple",
    //   headerStyle: { width: "3rem", whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "JobSheet",
      sortable: false,
      header: "Job No",
      filter: true,
      showFilterMenu: true,
      frozen: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "complaintReportedOn",
      sortable: true,
      header: "Complaint Reported On",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.complaintReportedOn),
      isDefault: true,
      isStatic: false,
      filterElement: dateFilterTemplate,
    },
    {
      field: "creationTime",
      sortable: true,
      header: "Creation Time",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.creationTime),
      isDefault: true,
      isStatic: false,
      filterElement: dateFilterTemplate,
    },
    {
      field: "jobPrefix",
      sortable: true,
      header: "Job Prefix",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "partDespatchedFromMelOn",
      sortable: false,
      header: "Part Dispatched From Mel On",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.partDespatchedFromMelOn),
      isDefault: true,
      isStatic: false,
      filterElement: dateFilterTemplate,
    },

    // {
    //   field: "melTat",
    //   sortable: true,
    //   header: "Mel TAT",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    //   className: "align-right",
    //   // body: (rowData: any) => headerTemplate(rowData.melTat)
    //   body: (rowData: any) => headerTemplate(((rowData.melTat ? rowData.melTat : 0) + 1) / 60)
    // },
    {
      field: "partReceivedByMelOn",
      sortable: false,
      header: "Part Received By Mel On",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "100px" },
      body: (rowData) => formatDateMEL(rowData.partReceivedByMelOn),
      isDefault: true,
      isStatic: false,
      tooltip: true,
      filterElement: dateFilterTemplate,
    },
    {
      field: "toatlTat",
      sortable: false,
      header: "Total Tat",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      // body: (rowData) => formatDateMEL(rowData.packageSendAt),
      isDefault: true,
      isStatic: false,
      className: "align-right",
      body: (rowData: any) => headerTemplate(((rowData.toatlTat ? rowData.toatlTat : 0) + 1) / 60)
    },
    // {
    //   field: "total",
    //   sortable: false,
    //   header: "Total",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: false,
    //   isStatic: false,
    // },
    {
      field: "model",
      sortable: false,
      header: "Model",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "dealerName",
      sortable: false,
      header: "Dealer Name",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "location",
      sortable: false,
      header: "Location",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "dealerCode",
      sortable: false,
      header: "Dealer Code",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "dealerContactPerson",
      sortable: false,
      header: "Dealer Contact Person",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "dealerContactMobile",
      sortable: false,
      header: "Dealer Contact Mobile",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      // body: (rowData) => statusBodyTemplate(rowData, 'isToPayCustomer'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "vinNumber",
      sortable: false,
      header: "Vin Number",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "audioSerialNumber",
      sortable: false,
      header: "Audio SI No",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "manufacturedDate",
      sortable: false,
      header: "Manufactured Date",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.manufacturedDate),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "vehicleSaleDate",
      sortable: false,
      header: "Vehicle Sale Date",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.vehicleSaleDate),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "vehicleRepairDate",
      sortable: false,
      header: "Vehicle Repair Date",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.vehicleRepairDate),
      isDefault: true,
      isStatic: false,
    },
    // {
    //   field: "mis",
    //   sortable: false,
    //   header: "MIS",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "warrantyStatus",
      sortable: false,
      header: "Warranty Status",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "kmsRun",
      sortable: false,
      header: "Kms Run",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      className: "align-right"
    },
    {
      field: "concernDescription",
      sortable: false,
      header: "Concern Description",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      className:"hover-class"
    },
    {
      field: "melSymptom",
      sortable: false,
      header: "Mel Symptom",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "replacementDetails",
      sortable: false,
      header: "Replacement Details",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "partReceivedByDealerOn",
      sortable: false,
      header: "Part Received By Dealer On",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      filterElement: dateFilterTemplate,
    },
    {
      field: "estimateGivenDate",
      sortable: false,
      header: "Estimate Given Date",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      body: (rowData) => formatDateMEL(rowData.estimateGivenDate),
      filterElement: dateFilterTemplate,
    },
    {
      field: "approvedDate",
      sortable: false,
      header: "Approved Date",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      filterElement: dateFilterTemplate,
    },
    // {
    //   field: "zone",
    //   sortable: false,
    //   header: "Zone",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    // {
    //   field: "parts",
    //   sortable: false,
    //   header: "Parts",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "status",
      sortable: false,
      header: "Status",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "customerName",
      sortable: false,
      header: "Customer Name",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    // {
    //   field: "customerContactPerson",
    //   sortable: false,
    //   header: "Customer Contact Person",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    // {
    //   field: "customerContactMobile",
    //   sortable: false,
    //   header: "Customer Contact Mobile",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "isExchange",
      sortable: false,
      header: "Is Exchange",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'isExchange'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "isFaultySystemAvailable",
      sortable: false,
      header: "Is Faulty System Available",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'isFaultySystemAvailable'),
      isDefault: true,
      isStatic: false,
    },
  ];
  const { showToast } = useToast();
  const [visible, setVisible] = useState(false);
  const [selectedStatus, setselectedStatus] = useState(ACTIVE);
  const [rowData, setRowData] = useState<any | null>(null);
  const [lazyState, setLazyState] = useState(initialLazyState);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedJobReport, setSelectedJobReport] = useState<any[]>([]);
  const [archiveModal, setArchiveModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showCustomizeTable, setShowCustomizeTable] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(columns.filter((eachColumn: Columns) => eachColumn.isDefault));
  const navigate = useNavigate();
  const [filter, setFilter] = useState(false);
  const dt = useRef<DataTable<any>>(null);
  const dispatch = useDispatch();
  const { loading, error, message, jobSheetReportList } = useSelector((state: RootReducerState) => state.jobSheetReportReducer);
  const [pdfLoading, setPdfLoading] = useState<boolean>(false);

  const { totalCount } = useSelector((state: RootReducerState) => state.jobSheetReportReducer.jobSheetReportList);

  const modifiedValues: any[] = useMemo(() => {return jobsheetReportListConverson(jobSheetReportList) }, [jobSheetReportList]);
  console.log(modifiedValues)
  const hidePopup = () => {
    setVisible(false);
    // dispatch(); 
  };

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const defaultColumns = {
    ...columns[0]
  };

  const customizeTableCancelHandler = () => {
    setShowCustomizeTable(false);
  };

  const initialValues = {
    status: "",
  };

  const validationSchema = Yup.object({});

  const dialogContainer = (error: any) => {
    return (<ValidationPopup error={error} visible={visible} onHide={hidePopup} />);
  };

  const customizeTableColumns: customizeTableColumns[] = columns.map((eachColumns: Columns) => {
    let data: any = {};
    data['field'] = eachColumns.field;
    data['value'] = visibleColumns.some((sCol: any) => sCol.field === eachColumns.field);
    data['isDisable'] = eachColumns.isStatic;
    data['header'] = eachColumns.header;
    return data;
  }).filter((eachColumns: customizeTableColumns) => eachColumns.field != 'select');

  const customizeColumnSubmitHandler = (customizeColumnObject: any[]) => {
    let orderedSelectedColumns = columns.filter((col) => customizeColumnObject.some((sCol: any) => sCol === col.field));
    setVisibleColumns([...orderedSelectedColumns]);
    setShowCustomizeTable(false);
  };

  const onSelectionChange = (event: any) => {
    const value = event.value;
    setSelectedJobReport(value);
    // setSelectAll(value.length === paginatorCount);
  };

  useEffect(() => {
    if (error) {
      setVisible(true);
      // showToast(error, { type: "error" })
    }
    if (message) {
      showToast(message, { type: "success" });
    }
  }, [error, message]);

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading || pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading, pdfLoading]);

  const onSelectAllChange = (event: any) => {
    const selectAll = event.checked;
    if (selectAll) {
      if (selectedStatus == LOCKED) {
        setSelectAll(false);
        setSelectedJobReport([]);
      } else if (selectedStatus == ACTIVE) {
        // let len = modifiedValues?.length;
        // let filterLen = modifiedValues?.filter((eachValue: any) => !eachValue.locked).length;
        // if (len === filterLen) {
        //   setSelectAll(true);
        //   setSelectedJobReport(modifiedValues);
        // } 
        // else {
        //   setSelectAll(false);
        //   setSelectedJobReport(modifiedValues?.filter((eachValue: any) => !eachValue.locked));
        // }
      }
      else {
        setSelectAll(true);
        // setSelectedJobReport(modifiedValues);
      }
    } else {
      setSelectAll(false);
      setSelectedJobReport([]);
    }
  };

  const handleSubmit = (formValue: any) => {
    setselectedStatus(formValue);
    if (formValue == ACTIVE) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "false", matchMode: "contains" },
          packageSent: { value: null, matchMode: "contains" },
          packageNotSent: { value: null, matchMode: "contains" },

        },
      }));
    }
    else if (formValue == DELETED) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "true", matchMode: "contains" },
          packageSent: { value: "false", matchMode: "contains" },
          packageNotSent: { value: "false", matchMode: "contains" },
        },
      }));
    }
    else if (formValue == PACKAGESENT) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "false", matchMode: "contains" },
          packageSent: { value: "true", matchMode: "contains" },
          packageNotSent: { value: "false", matchMode: "contains" },

        },
      }));
    } else if (formValue == PACKAGENOTSENT) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "false", matchMode: "contains" },
          Locked: { value: "false", matchMode: "contains" },
          packageNotSent: { value: "true", matchMode: "contains" },
          packageSent: { value: "false", matchMode: "contains" },
        },
      }));
    } else if (formValue == ALL) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: "false", matchMode: "contains" },
          Locked: { value: "false", matchMode: "contains" },
          packageNotSent: { value: "false", matchMode: "contains" },
          packageSent: { value: "false", matchMode: "contains" },
          all: { value: "true", matchMode: "contains" },
        },
      }));
    }
    else {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          IsDeleted: { value: null, matchMode: "contains" },
          packageSent: { value: null, matchMode: "contains" },
          packageNotSent: { value: null, matchMode: "contains" },
        },
      }));
    }
  };

  const handleReset = (formValue: any) => {
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: "",
        }
      },
    }));
  };

  const options: Option[] = [
    { label: "Active", value: "Active" },
    { label: "Deleted", value: "Deleted" },
  ];

  const handleStatusBlur = () => { };

  const onSort = (event: any) => {
    setLazyState(event);
  };
  const onFilter = (event: any) => {
    event["first"] = 0;
    event['filters']['EstimateGivenStartDate']['value'] = event?.filters?.estimateGivenDate?.value?.startDate ? event?.filters?.estimateGivenDate?.value?.startDate : '';
    event['filters']['EstimateGivenEndDate']['value'] = event?.filters?.estimateGivenDate?.value?.endDate ? event?.filters?.estimateGivenDate?.value?.endDate : '';
    event['filters']['ApprovedStartDate']['value'] = event?.filters?.approvedDate?.value?.startDate ? event?.filters?.approvedDate?.value?.startDate : '';
    event['filters']['ApprovedEndDate']['value'] = event?.filters?.approvedDate?.value?.endDate ? event?.filters?.approvedDate?.value?.endDate : '';
    event['filters']['PartReceivedOnMelStartDate']['value'] = event?.filters?.partReceivedByMelOn?.value?.startDate ? event?.filters?.partReceivedByMelOn?.value?.startDate : '';
    event['filters']['PartReceivedOnMelEndDate']['value'] = event?.filters?.partReceivedByMelOn?.value?.endDate ? event?.filters?.partReceivedByMelOn?.value?.endDate : '';
    event['filters']['CompalintReportedStartDate']['value'] = event?.filters?.complaintReportedOn?.value?.startDate ? event?.filters?.complaintReportedOn?.value?.startDate : '';
    event['filters']['CompalintReportedEndDate']['value'] = event?.filters?.complaintReportedOn?.value?.endDate ? event?.filters?.complaintReportedOn?.value?.endDate : '';
    event['filters']['CreationTimeStartDate']['value'] = event?.filters?.creationTime?.value?.startDate ? event?.filters?.creationTime?.value?.startDate : '';
    event['filters']['CreationTimeEndDate']['value'] = event?.filters?.creationTime?.value?.endDate ? event?.filters?.creationTime?.value?.endDate : '';
    event['filters']['PartDispatchedOnMelStartDate']['value'] = event?.filters?.partDespatchedFromMelOn?.value?.startDate ? event?.filters?.partDespatchedFromMelOn?.value?.startDate : '';
    event['filters']['PartDispatchedOnMelEndDate']['value'] = event?.filters?.partDespatchedFromMelOn?.value?.endDate ? event?.filters?.partDespatchedFromMelOn?.value?.endDate : '';
    event['filters']['PartReceivedByDealerStartDate']['value'] = event?.filters?.partReceivedByDealerOn?.value?.startDate ? event?.filters?.partReceivedByDealerOn?.value?.startDate : '';
    event['filters']['PartReceivedByDealerEndDate']['value'] = event?.filters?.partReceivedByDealerOn?.value?.endDate ? event?.filters?.partReceivedByDealerOn?.value?.endDate : '';
    setLazyState(event);
  };

  const onPage = (event: any) => {
    setLazyState(event);
  };

  const bulkActionClickHandler = () => {
    // if (modifiedValues.length > 0) {
    //   setSelectAll(true);
    //   setSelectedCourier(modifiedValues);
    // }
  };

  const cancelBulkActionHadler = () => {
    setSelectAll(false);
    setSelectedJobReport([]);
  };

  const customizeTableClickHandler = () => {
    setShowCustomizeTable(true);
  };

  const changeColumnDetails = (values: any[]) => {
    let modifiedColumnDetails = values.map((eachValue) => {
      let data: any = {};
      data['JobSheet'] = eachValue?.JobSheet;
      data['complaintReportedOn'] = formatDateMELForExcel(eachValue?.complaintReportedOn);
      data['partDespatchedFromMelOn'] = formatDateMELForExcel(eachValue?.partDespatchedFromMelOn);
      data['creationTime'] = formatDateMELForExcel(eachValue?.creationTime);
      // data['melTat'] = eachValue?.melTat;
      data['partReceivedByMelOn'] = formatDateMELForExcel(eachValue?.partReceivedByMelOn);
      data['toatlTat'] = eachValue?.toatlTat;
      // data['total'] = eachValue?.total;
      data['model'] = eachValue?.model;
      data['dealerName'] = eachValue?.dealerName;
      data['location'] = eachValue?.location;
      data['dealerCode'] = eachValue?.dealerCode;
      data['dealerContactPerson'] = eachValue?.dealerContactPerson;
      data['vinNumber'] = eachValue?.vinNumber;
      data['audioSerialNumber'] = eachValue?.audioSerialNumber;
      data['manufacturedDate'] = formatDateMELForExcel(eachValue?.manufacturedDate);
      data['vehicleSaleDate'] = formatDateMELForExcel(eachValue?.vehicleSaleDate);
      data['vehicleRepairDate'] = formatDateMELForExcel(eachValue?.vehicleRepairDate);
      // data['mis'] = eachValue?.mis;
      data['warrantyStatus'] = eachValue?.warrantyStatus;
      data['kmsRun'] = eachValue?.kmsRun;
      data['concernDescription'] = eachValue?.concernDescription;
      data['melSymptom'] = eachValue?.melSymptom;
      data['replacementDetails'] = eachValue?.replacementDetails;
      data['partReceivedByDealerOn'] = eachValue?.partReceivedByDealerOn;
      data['estimateGivenDate'] = formatDateMELForExcel(eachValue?.estimateGivenDate);
      data['approvedDate'] = eachValue?.approvedDate;
      // data['zone'] = eachValue?.zone;
      // data['parts'] = eachValue?.parts;
      data['status'] = eachValue?.status;
      data['customerName'] = eachValue?.customerName;
      // data['customerContactPerson'] = eachValue?.customerContactPerson;
      // data['customerContactMobile'] = eachValue?.customerContactMobile;
      data['isExchange'] = eachValue?.isExchange;
      data['isFaultySystemAvailable'] = eachValue?.isFaultySystemAvailable;
      return { ...data };
    });
    return modifiedColumnDetails;
  };

  const saveDataAsExcel = (values: any[], fileName: string) => {
    const modifiedColumnDetails = changeColumnDetails(values);
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };
  const fetchData = async (isPdf: boolean) => {
    let state: any = {
      ...lazyState,
      rows: totalCount > 5000 ? 5000 : totalCount < 1 ? 1 : totalCount,
      first: 0,
      filters: {
        ...lazyState.filters,
      },
    };

    try {
      setPdfLoading(true);
      const response = await API.getJobSheetReportsApi(state);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      const modifeidValue = response?.data?.items?.map((eachValue: any) => {
        let data: any = {};
        data['id'] = eachValue?.id;
        data['JobSheet'] = eachValue?.jobNumber;
        data['complaintReportedOn'] = eachValue?.complaintReportedOn;
        data['partDespatchedFromMelOn'] = eachValue?.partDispatchedFromMelOn;
        data['melTat'] = eachValue?.melTat;
        data['partReceivedByMelOn'] = eachValue?.partReceivedByMelOn;
        data['toatlTat'] = eachValue?.totalTat;
        data['total'] = eachValue?.total;  // --missing
        data['model'] = eachValue?.model ? eachValue?.model : "-";
        data['dealerName'] = eachValue?.dealerName ? eachValue?.dealerName : "-";
        data['location'] = eachValue?.location ? eachValue?.location : "-";
        data['dealerCode'] = eachValue?.dealerCode ? eachValue?.dealerCode : "-";
        data['dealerContactPerson'] = eachValue?.dealerContactPerson ? eachValue?.dealerContactPerson : "-";
        data['dealerContactMobile'] = eachValue?.dealerContactMobile ? eachValue?.dealerContactMobile : "-";
        data['vinNumber'] = eachValue?.vinNumber ? eachValue?.vinNumber : "-";
        data['audioSerialNumber'] = eachValue?.audioSerialNumber ? eachValue?.audioSerialNumber : "-";
        data['manufacturedDate'] = eachValue?.manuFacturedDate;
        data['vehicleSaleDate'] = eachValue?.vehicleSaleDate;
        data['vehicleRepairDate'] = eachValue?.vehicleRepairDate;
        data['mis'] = eachValue?.mis ? eachValue?.mis : "-";
        data['warrantyStatus'] = eachValue?.warrantyStatus ? eachValue?.warrantyStatus : "-";
        data['kmsRun'] = eachValue?.kmsRun ? eachValue?.kmsRun : "-";
        data['concernDescription'] = eachValue?.concernDescription ? convertTagToText(eachValue?.concernDescription) : "-";
        data['melSymptom'] = convertTagToText(eachValue?.melSymptom);
        data['replacementDetails'] =convertTagToText(eachValue?.replacementDetail);
        data['partReceivedByDealerOn'] = eachValue?.partReceivedByDealerOn;
        data['estimateGivenDate'] = eachValue?.estimationDate;
        data['approvedDate'] = formatDateMEL(eachValue?.estimationApprovedDate);
        data['zone'] = eachValue?.zone;
        data['parts'] = eachValue?.parts;
        data['status'] = eachValue?.status;
        data['customerName'] = eachValue?.customerName; // --missing
        data['customerContactPerson'] = eachValue?.customerContactPerson;
        data['customerContactMobile'] = eachValue?.customerContactMobile;
        data['isExchange'] = eachValue?.isExchange;
        data['isFaultySystemAvailable'] = eachValue?.isFaultySystemAvailable;
        data['jobPrefix'] = eachValue?.jobPrefix;
        data['creationTime'] = eachValue?.creationTime;
        return data;
      })?.sort((a: any, b: any) => {
        if (a?.JobSheet === null) return 1;
        if (b?.JobSheet === null) return -1;
      
        return a?.JobSheet?.localeCompare(b?.JobSheet);
      });
      if (isPdf) {

        saveDataAsPdf(modifeidValue, columns, "jobsheet Reports");
      } else {
        saveDataAsExcel(modifeidValue, "jobsheet Reports");
      }
      setPdfLoading(false);
    } catch (error) {
      setPdfLoading(false);

    } finally {
      setPdfLoading(false);
    }
  };
  const csvClickHandler = () => {
    fetchData(false);
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    let pdfNeed=["JobSheet","creationTime","toatlTat","model","dealerName","vinNumber","customerName","warrantyStatus","status","isExchange","isFaultySystemAvailable"];
    let columnsNew = columns.filter((eachColumn: Columns) => pdfNeed.includes(eachColumn.field));
    debugger
    const destructureedData = values.map((eachValue) => {
      let datas = {
        id: eachValue.id,
        JobSheet: eachValue?.JobSheet,
        complaintReportedOn: formatDateMEL(eachValue?.complaintReportedOn),
        creationTime: formatDateMEL(eachValue?.creationTime),
        partDespatchedFromMelOn: formatDateMEL(eachValue?.partDespatchedFromMelOn),
        melTat: eachValue?.melTat,
        partReceivedByMelOn: formatDateMEL(eachValue?.partReceivedByMelOn),
        toatlTat: eachValue?.toatlTat,
        total: eachValue?.total,
        model: eachValue?.model,
        dealerName: eachValue?.dealerName,
        location: eachValue?.location,
        dealerCode: eachValue?.dealerCode,
        dealerContactPerson: eachValue?.dealerContactPerson,
        vinNumber: eachValue?.vinNumber,
        audioSerialNumber: eachValue?.audioSerialNumber,
        manufacturedDate: formatDateMEL(eachValue?.manufacturedDate),
        vehicleSaleDate: formatDateMEL(eachValue?.vehicleSaleDate),
        vehicleRepairDate: formatDateMEL(eachValue?.vehicleRepairDate),
        mis: eachValue?.mis,
        warrantyStatus: eachValue?.warrantyStatus,
        kmsRun: eachValue?.kmsRun,
        concernDescription: eachValue?.concernDescription,
        melSymptom: eachValue?.melSymptom ,
        replacementDetails: eachValue?.replacementDetails,
        partReceivedByDealerOn: eachValue?.partReceivedByDealerOn,
        estimateGivenDate: formatDateMEL(eachValue?.estimateGivenDate),
        approvedDate: eachValue?.approvedDate,
        zone: eachValue?.zone,
        parts: eachValue?.parts,
        status: eachValue?.status,
        customerName: eachValue?.customerName,
        customerContactPerson: eachValue?.customerContactPerson,
        customerContactMobile: eachValue?.customerContactMobile,
        isExchange: eachValue?.isExchange,
        isFaultySystemAvailable: eachValue?.isFaultySystemAvailable,
        jobPrefix: eachValue?.jobPrefix,
      };
      return datas;
    });
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columnsNew.map((col) => ({
          title: col.header,
          dataKey: col.field,
        }));
        const doc = new (jsPDF as any).default({
          orientation: 'landscape',
          format: 'a2',
        });
        doc.autoTable(exportColumns, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };

  const pdfClickHandler = () => {
    fetchData(true);
  };

  const clearFilter = () => {
    setLazyState(initialLazyState);
    setselectedStatus(ACTIVE);
  };
  const header =
    <div className="table-header-container">
      <div>
        Job Sheet Reports
      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
        <div style={{ display: "flex" }}>
          <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} clearFilter={clearFilter} isFilter={true} />
          <Button type="button" className="customize-table-button mt-1" id="ScheduleUpdateTooltip"
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)} data-btn="btn" onClick={customizeTableClickHandler} style={{ paddingLeft: "0px" }}>
            <FeatherIcon icon="sliders" />
          </Button>
        </div>
        <UncontrolledTooltip
          placement="bottom"
          target="ScheduleUpdateTooltip"
          isOpen={tooltipOpen}
          toggle={toggleTooltip}
          innerClassName="tooltip-color"
        >
          Choose fields you want to see in the table
        </UncontrolledTooltip>
      </div>

    </div>;

  const callbackFunction = (lazyState: LazyTableState) => {
    let modifiedLazyState: any = { ...lazyState };
    if (modifiedLazyState.filters && modifiedLazyState.filters.partReceivedByDealerOn.value != "") {
      modifiedLazyState.filters.partReceivedByDealerOn.value = "";
    } else if (modifiedLazyState.filters && modifiedLazyState.filters.estimateGivenDate.value != "" && modifiedLazyState.filters.estimateGivenDate.value != null) {
      modifiedLazyState.filters.estimateGivenDate.value = "";
    } else if (modifiedLazyState.filters && modifiedLazyState.filters.approvedDate.value != "" && modifiedLazyState.filters.approvedDate.value != null) {
      modifiedLazyState.filters.approvedDate.value = "";
    } else if (modifiedLazyState.filters && modifiedLazyState.filters.partReceivedByMelOn.value != "" && modifiedLazyState.filters.partReceivedByMelOn.value != null) {
      modifiedLazyState.filters.partReceivedByMelOn.value = "";
    } else if (modifiedLazyState.filters && modifiedLazyState.filters.complaintReportedOn.value != "" && modifiedLazyState.filters.complaintReportedOn.value != null) {
      modifiedLazyState.filters.complaintReportedOn.value = "";
    } else if (modifiedLazyState.filters && modifiedLazyState.filters.partDespatchedFromMelOn.value != "" && modifiedLazyState.filters.partDespatchedFromMelOn.value != null) {
      modifiedLazyState.filters.partDespatchedFromMelOn.value = "";
    }
    dispatch(getJobSheetReportsLoading(modifiedLazyState));
  };

  useEffect(() => {
    setSelectAll(false);
    setSelectedJobReport([]);
    callbackFunction(lazyState);
    return () => {
      // dispatch(clearCourierMessage());
    };
  }, [lazyState]);

  return (
    <React.Fragment>
      <div className="page-content">
        {visible && dialogContainer(error)}
        {showCustomizeTable && <CustomizeTable onCancelHandler={customizeTableCancelHandler} onCustomizeColumnSubmitHandler={customizeColumnSubmitHandler} columns={customizeTableColumns} />}
        {filter && (
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                onReset={handleReset}
                enableReinitialize
              >
                {({ values, handleChange }) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row id="export-search-clear">
                        <Col xs={12} lg={7} >

                        </Col>
                        <Col xs={12} lg={5} className="select-clear-search-container d-flex">
                          <Select
                            label=""
                            name="status"
                            onBlur={handleStatusBlur}
                            value={values.status}
                            onChange={handleChange}
                            options={options}
                            invalid={false}
                          />
                          <Button className="btn btn-primary ms-2" color="primary" type="reset">
                            Clear </Button>
                          <Button className="btn btn-primary ms-2" color="primary" type="submit">
                            Search </Button>
                        </Col>

                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        )}

        <DataTableWrapper
          ref={dt}
          columnDetails={visibleColumns}
          header={header}
          value={modifiedValues}
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          filterIcon={FilterIcon}
          lazy
          paginator={true}
          stripedRows={true}
          rowHover={true}
          // filterDisplay="row"
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalCount}
          loading={loading}
          emptyMessage="No details found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying Job sheet reports  {last} records of {totalRecords} in total"
          selection={selectedJobReport}
          onSelectionChange={onSelectionChange}
          selectAll={selectAll}
          onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
          selectionMode="checkbox"
        // rowClassName={rowClassName}
        >
        </DataTableWrapper>
      </div>
    </React.Fragment>
  );
};

export default JobSheetReports;